import type { TOC } from '@ember/component/template-only';
import MarketCustomReportingSidebar from 'lumen/components/market/custom-reporting/sidebar';
import type DestinationReportingController from 'lumen/controllers/destination/reporting';

import styles from './reporting.module.css';

interface DestinationReportingSignature {
  Args: {
    controller: DestinationReportingController;
    model: unknown;
  };
}

<template>
  <div class="{{styles.container}} h-full">
    <div class="{{styles.sidebar}} flex h-full flex-row">
      <MarketCustomReportingSidebar
        @folders={{@controller.folders}}
        @foldersOnly={{true}}
        @foldersType="templates"
        @isLoading={{@controller.model.folders.isRunning}}
        @selectedDashboard={{@controller.customReporting.selectedDashboard}}
        @viewOnly={{false}}
      />
      {{outlet}}
    </div>
  </div>
</template> satisfies TOC<DestinationReportingSignature>;
